import React, { useEffect, useState } from "react";
import Aos from "aos";

const ProjectCards = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  const [viewMore, setViewmore] = useState();
  return (
    <div className="flex flex-col items-center justify-center mt-8 gap-6 p-2 md:p-4 lg:p-6 ">
      {/* *** */}
      <div className="flex flex-wrap justify-center gap-6 ">
        <div
          data-aos="fade-down-left"
          className="w-[300px] h-[320px] text-center bg-[#1F1F38] cursor-pointer rounded-lg  hover:scale-105 duration-500"
        >
          <div className="bg-gray-300 rounded-t-lg ">
            <img
              src="./fashion.png"
              alt="fashionImage"
              className="w-[300px] h-[150px] p-2"
            />
          </div>
          <div className="flex flex-col items-start gap-4 p-4">
            <div className="flex flex-col gap-2 text-start">
              <h1 className="text-[20px] text-[#F5F5F7] font-bold">
                Reed Xclusive
              </h1>
              <p className="text-[14px] text-[#A2A2AD] ">
                A fashion site built with Reactjs and Tailwind CSS.
              </p>
            </div>
            <div className="flex gap-4 font-bold">
              <button className="border-2 border-[#A2A2AD] px-6 py-1 rounded-lg duration-700 hover:scale-105 hover:bg-[#E84949]">
                <a href="https://reedxclusivefashion.vercel.app/">Live</a>
              </button>
              <button className="border-2 border-[#A2A2AD] px-6 py-1 rounded-lg duration-700 hover:scale-105  hover:bg-[#E84949]">
                <a href="https://github.com/eedrisofficial/Fashion-site">
                  Github
                </a>
              </button>
            </div>
          </div>
        </div>

        {/* *** */}

        <div
          data-aos="zoom-in-up"
          className="w-[300px] h-[320px] text-center bg-[#1F1F38] cursor-pointer rounded-lg  hover:scale-105 duration-500"
        >
          <div className="bg-gray-300 rounded-t-lg ">
            <img
              src="./bitmedics.png"
              alt="bitmedics"
              className="w-[300px] h-[150px] p-2"
            />
          </div>
          <div className="flex flex-col items-start gap-4 p-4">
            <div className="flex flex-col gap-2 text-start">
              <h1 className="text-[20px] text-[#F5F5F7] font-bold">
                Bitmedics
              </h1>
              <p className="text-[14px] text-[#A2A2AD] ">
                An electronic health record management system website.
              </p>
            </div>
            <div className="flex gap-4 font-bold">
              <button className="border-2 border-[#A2A2AD] px-6 py-1 rounded-lg duration-700 hover:scale-105 hover:bg-[#E84949]">
                <a href="https://bitmedics-app.vercel.app/">Live</a>
              </button>
            </div>
          </div>
        </div>
        {/* ** */}
        <div
          data-aos="fade-down-right"
          className="w-[300px] h-[320px] text-center bg-[#1F1F38] cursor-pointer rounded-lg  hover:scale-105 duration-500"
        >
          <div className="bg-gray-300 rounded-t-lg ">
            <img
              src="./todoist.png"
              alt="todoImage"
              className="w-[300px] h-[150px] p-2"
            />
          </div>
          <div className="flex flex-col items-start gap-4 p-4">
            <div className="flex flex-col gap-2 text-start">
              <h1 className="text-[20px] text-[#F5F5F7] font-bold">
                Reed Todoist
              </h1>
              <p className="text-[14px] text-[#A2A2AD] ">
                A To-do-list website to organize your work, built with React and
                tailwind CSS.
              </p>
            </div>
            <div className="flex gap-4 font-bold">
              <button className="border-2 border-[#A2A2AD] px-6 py-1 rounded-lg duration-700 hover:scale-105 hover:bg-[#E84949]">
                <a href="https://todoistwebapp.vercel.app/">Live</a>
              </button>
              <button className="border-2 border-[#A2A2AD] px-6 py-1 rounded-lg duration-700 hover:scale-105  hover:bg-[#E84949]">
                <a href="https://github.com/eedrisofficial/newTodo">Github</a>
              </button>
            </div>
          </div>
        </div>
      </div>
      <button
        className={
          viewMore
            ? "hidden"
            : "bg-[#E84949] lg:w-[15%] p-3 rounded-md hover:bg-[#0f0f1e] duration-500"
        }
        onClick={() => setViewmore(!viewMore)}
      >
        View more
      </button>
      {/* *** */}

      <div
        className={
          viewMore
            ? "flex flex-wrap gap-6 justify-center duration-500"
            : "hidden"
        }
      >
        <div className="w-[300px] h-[320px] text-center bg-[#1F1F38] cursor-pointer rounded-lg  hover:scale-105 duration-500">
          <div className="bg-gray-300 rounded-t-lg ">
            <img
              src="./hotel.png"
              alt="hotelImage"
              className="w-[300px] h-[150px] p-2"
            />
          </div>
          <div className="flex flex-col items-start gap-4 p-4">
            <div className="flex flex-col gap-2 text-start">
              <h1 className="text-[20px] text-[#F5F5F7] font-bold">
                HIA Hotel
              </h1>
              <p className="text-[14px] text-[#A2A2AD] ">
                Hotel website portfolio built with HTML, CSS, and JavaScript.
              </p>
            </div>
            <div className="flex gap-4 font-bold">
              <button className="border-2 border-[#A2A2AD] px-6 py-1 rounded-lg duration-700 hover:scale-105 hover:bg-[#E84949]">
                <a href="https://hiahotel.vercel.app/">Live</a>
              </button>
              <button className="border-2 border-[#A2A2AD] px-6 py-1 rounded-lg duration-700 hover:scale-105  hover:bg-[#E84949]">
                <a href="https://github.com/eedrisofficial/hotel-project">
                  Github
                </a>
              </button>
            </div>
          </div>
        </div>
        {/* *** */}
        <div className="w-[300px] h-[320px] text-center bg-[#1F1F38] cursor-pointer rounded-lg  hover:scale-105 duration-500">
          <div className="bg-gray-300 rounded-t-lg ">
            <img
              src="./userdata.png"
              alt="usersImage"
              className="w-[300px] h-[150px] p-2"
            />
          </div>
          <div className="flex flex-col items-start gap-4 p-4">
            <div className="flex flex-col gap-2 text-start">
              <h1 className="text-[20px] text-[#F5F5F7] font-bold">
                User Data
              </h1>
              <p className="text-[14px] text-[#A2A2AD] ">
                Search Users table built with HTML, CSS, and JavaScript.
              </p>
            </div>
            <div className="flex gap-4 font-bold">
              <button className="border-2 border-[#A2A2AD] px-6 py-1 rounded-lg duration-700 hover:scale-105 hover:bg-[#E84949]">
                <a href="https://search-usersdata-table.netlify.app/">Live</a>
              </button>
              <button className="border-2 border-[#A2A2AD] px-6 py-1 rounded-lg duration-700 hover:scale-105  hover:bg-[#E84949]">
                <a href="https://github.com/eedrisofficial/USER-DATA">Github</a>
              </button>
            </div>
          </div>
        </div>
        {/* *** */}
        <div className="w-[300px] h-[320px] text-center bg-[#1F1F38] cursor-pointer rounded-lg  hover:scale-105 duration-500">
          <div className="bg-gray-300 rounded-t-lg ">
            <img
              src="./cashride.png"
              alt="cashImage"
              className="w-[300px] h-[150px] p-2"
            />
          </div>
          <div className="flex flex-col items-start gap-4 p-4">
            <div className="flex flex-col gap-2 text-start">
              <h1 className="text-[20px] text-[#F5F5F7] font-bold">
                Cash Ride
              </h1>
              <p className="text-[14px] text-[#A2A2AD] ">
                Retirement business plan website built with HTML, CSS, and
                JavaScript.
              </p>
            </div>
            <div className="flex gap-4 font-bold">
              <button className="border-2 border-[#A2A2AD] px-6 py-1 rounded-lg duration-700 hover:scale-105 hover:bg-[#E84949]">
                <a href="https://cashridepension.vercel.app/">Live</a>
              </button>
              <button className="border-2 border-[#A2A2AD] px-6 py-1 rounded-lg duration-700 hover:scale-105  hover:bg-[#E84949]">
                <a href="https://github.com/eedrisofficial/pension-website">
                  Github
                </a>
              </button>
            </div>
          </div>
        </div>
        {/* *** */}
      </div>
      <button
        className={
          viewMore
            ? "bg-[#E84949] lg:w-[15%] p-3 rounded-md hover:bg-[#0f0f1e] duration-500"
            : "hidden"
        }
        onClick={() => setViewmore(!viewMore)}
      >
        Close
      </button>

      {/* *** */}
    </div>
  );
};

export default ProjectCards;
